/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/*********************** Custom JS for Boost AI Search & Discovery  ************************/


const customize = {

  moveHeaderDescription: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductList', {
      name: 'Product List component',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          document.dispatchEvent(new CustomEvent('limoniapps:discountninja:collection:productsadded'));
        }
      }),

    });
  }
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.moveHeaderDescription,
]);
